<template>
  <div class="login-page">
    <!-- Background shapes -->
    <div class="bg-shape bg-shape-1"></div>
    <div class="bg-shape bg-shape-2"></div>
    <div class="bg-shape bg-shape-3"></div>

    <FormLogin />
  </div>
</template>

<script>
import FormLogin from '@/components/auth/FormLogin.vue'
import Auth from '@/services/auth.service.js'

export default {
  components: { FormLogin },
  mounted() {
    let auth = Auth.checkAuth();
    if (auth) {
      this.$router.replace({ name: "home" });
    }
  },
}
</script>

<style scoped>
.login-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  width: 100%;
  background: linear-gradient(135deg, #e8f4fc 0%, #f0f9ff 50%, #e0f2fe 100%);
  padding: 20px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  direction: rtl;
}

/* Decorative background blobs */
.bg-shape {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
}

.bg-shape-1 {
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(14, 129, 196, 0.12) 0%, transparent 70%);
  top: -150px;
  right: -100px;
}

.bg-shape-2 {
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(10, 107, 163, 0.1) 0%, transparent 70%);
  bottom: -100px;
  left: -80px;
}

.bg-shape-3 {
  width: 250px;
  height: 250px;
  background: radial-gradient(circle, rgba(26, 154, 214, 0.08) 0%, transparent 70%);
  top: 40%;
  left: 30%;
}
</style>